// Type definitions for the possible native bridges

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };

    Android?: {
      postMessage: (message: string) => void;
    };

    webkit?: {
      messageHandlers?: {
        iosHandler?: {
          postMessage: (message: string) => void;
        };
        [key: string]:
          | {
              postMessage: (message: string) => void;
            }
          | undefined;
      };
    };
  }
}

export type NativeMessage = string | Record<string, unknown>;

/**
 * Send a message from a WebView-based React app to the hosting native app.
 * Automatically detects RN WebView, Android WebView, or iOS WKWebView.
 */
export function postToNative(payload: NativeMessage): void {
  const message =
    typeof payload === "string" ? payload : JSON.stringify(payload);

  // React Native WebView
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(message);
    return;
  }

  // Android WebView (JavascriptInterface)
  if (window.Android?.postMessage) {
    window.Android.postMessage(message);
    return;
  }

  // iOS WKWebView
  if (window.webkit?.messageHandlers) {
    // if they expose a handler named `iosHandler`
    if (window.webkit.messageHandlers.iosHandler?.postMessage) {
      window.webkit.messageHandlers.iosHandler.postMessage(message);
      return;
    }

    // or if they use another handler name (fallback)
    for (const handler of Object.values(window.webkit.messageHandlers)) {
      if (handler?.postMessage) {
        handler.postMessage(message);
        return;
      }
    }
  }

  // No native handler detected
  console.warn("No native WebView bridge detected. Message not sent:", message);
}
